import Component from '@glimmer/component';
import pageTitle from 'ember-page-title/helpers/page-title';
import { VStack, Header, Section } from 'tio-ui/components/layout';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import TuitionAssistanceFormsMentoring from 'tio-employee/components/tuition-assistance/forms/mentoring';
import embedCalendly from 'tio-common/modifiers/embed-calendly';
import type SessionContextService from 'tio-employee/services/session-context';
import type EmployeeModel from 'tio-data/models/employee';

interface CollegePlanningMentorsSignature {
  model: {
    employee: EmployeeModel;
    phoneScheduler?: boolean;
  };
  Element: HTMLElement;
}

export default class CollegePlanningMentorsComponent extends Component<CollegePlanningMentorsSignature> {
  @service declare sessionContext: SessionContextService;
  // @tracked showSchedulingCalendar = this.args.model.phoneScheduler || false;
  @tracked calendlyError = false;

  // Used to prefill data within the calendly widget
  get calendlyPrefillData() {
    return {
      firstName: this.sessionContext.user?.person.firstName,
      lastName: this.sessionContext.user?.person.lastName,
    };
  }

  get showSchedulingCalendar() {
    return this.args.model.phoneScheduler || false;
  }

  onCalendlyError = () => {
    this.calendlyError = true;
  };
  <template>
    {{pageTitle "Education Mentors"}}
    <VStack>
      <Header>{{t "college_planning_mentors.header"}}</Header>
      <Section>
        <VStack @collapsed={{true}}>
          {{#if this.showSchedulingCalendar}}
            <div
              id="calendly-container"
              class="h-[756px]"
              {{embedCalendly
                "https://calendly.com/tiocoaches"
                this.calendlyPrefillData
                this.onCalendlyError
              }}
            />
          {{else}}
            <Section>
              <:header>
                <p>{{t "college_planning_mentors.coaching"}}</p>
              </:header>
              <:body>
                <p>{{t "college_planning_mentors.question"}}</p>
              </:body>
            </Section>
            <Section>
              <:body>
                <p>{{t "college_planning_mentors.description"}}</p>
              </:body>
            </Section>
            <Section>
              <:body>
                <p class="font-semibold">{{t "college_planning_mentors.speak_with_a_coach"}}</p>
              </:body>
            </Section>
            <Section>
              <:body>
                <p>{{t "college_planning_mentors.please_answer"}}</p>
              </:body>
            </Section>
            <TuitionAssistanceFormsMentoring @employee={{@model.employee}} @isNonTa={{true}} />
          {{/if}}
        </VStack>
      </Section>
    </VStack>
  </template>
}
